# Generated by https://pagedraw.io/pages/11538
React = require 'react'
Backbutton = require './backbutton'
Star = require './star'
Installationhuge = require './installationhuge'
Componenttitle = require './componenttitle'
Componentlist = require './componentlist'
Componentpreview = require './componentpreview'


render = ->
    React.createElement("div", {"className": "libdetails-libdetails-2"},
        React.createElement("style", {"dangerouslySetInnerHTML": (__html: """
            @import url('https://fonts.googleapis.com/css?family=Lato:');
            
            .libdetails-libdetails-2 {
                display: flex;
                flex-direction: column;
                flex-grow: 1;
                padding-top: 20px;
                padding-bottom: 20px;
                background: rgb(251, 251, 251);
            }
            
            .libdetails-0 {
                display: flex;
                flex-shrink: 0;
                padding-left: 20px;
                padding-right: 20px;
            }
            
            .libdetails-rectangle_9 {
                display: flex;
                flex-direction: column;
                background: rgba(255, 255, 255, 0);
            }
            
            .libdetails-0-0-0 {
                display: flex;
                flex-shrink: 0;
                padding-right: 5px;
            }
            
            .libdetails-0-0-0-0 {
                display: flex;
                flex-direction: column;
                padding-top: 20px;
                padding-bottom: 9px;
            }
            
            .libdetails-0-0-0-0-0 {
                display: flex;
                flex-shrink: 0;
            }
            
            .libdetails-component_1 {
                flex-shrink: 0;
                display: flex;
                flex-direction: column;
            }
            
            .libdetails-material_ui_-3 {
                flex-shrink: 0;
                margin-left: 17px;
                font-family: "Lato", sans-serif;
                color: rgb(0, 0, 0);
                font-size: 48px;
                line-height: 55px;
                letter-spacing: 0px;
                font-weight: bold;
                font-style: normal;
                text-decoration: none;
                text-align: left;
                word-wrap: break-word;
                padding-right: 0.015625px;
            }
            
            .libdetails-0-1 {
                display: flex;
                flex-direction: column;
                margin-left: 20px;
                padding-top: 12px;
                padding-bottom: 3px;
            }
            
            .libdetails-0-1-0 {
                display: flex;
                flex-shrink: 0;
            }
            
            .libdetails-v_0 {
                width: 115px;
                flex-shrink: 0;
                font-family: "Lato", sans-serif;
                color: rgb(150, 150, 150);
                font-size: 21px;
                line-height: 24px;
                letter-spacing: 0px;
                font-weight: normal;
                font-style: normal;
                text-decoration: none;
                text-align: left;
                word-wrap: break-word;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
            
            .libdetails-0-1-1 {
                display: flex;
                flex-shrink: 0;
            }
            
            .libdetails-by_john_appleseed_-8 {
                width: 115px;
                flex-shrink: 0;
                font-family: "Lato", sans-serif;
                color: rgb(186, 186, 186);
                font-size: 14px;
                line-height: 16px;
                letter-spacing: 0px;
                font-weight: normal;
                font-style: normal;
                text-decoration: none;
                text-align: left;
                word-wrap: break-word;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
            
            .libdetails-rectangle_8 {
                display: flex;
                flex-direction: column;
                margin-left: 20px;
                padding-top: 7px;
                padding-bottom: 2px;
            }
            
            .libdetails-0-2-0 {
                display: flex;
                flex-shrink: 0;
                padding-right: 57px;
            }
            
            .libdetails-image_3 {
                width: 18px;
                height: 18px;
                flex-shrink: 0;
                background-image: url('https://complex-houses.surge.sh/cb96c502-cfc4-42c5-b16a-fdaff005e38b/original');
                background-size: contain;
                background-position: center;
                background-repeat: no-repeat;
            }
            
            .libdetails-0-2-0-1 {
                display: flex;
                flex-direction: column;
                margin-left: 10px;
                padding-top: 1px;
                padding-bottom: 1px;
            }
            
            .libdetails-0-2-0-1-0 {
                display: flex;
                flex-shrink: 0;
            }
            
            .libdetails-2 {
                flex-shrink: 0;
                font-family: "Lato", sans-serif;
                color: rgb(107, 107, 107);
                font-size: 14px;
                line-height: 16px;
                letter-spacing: 0px;
                font-weight: normal;
                font-style: normal;
                text-decoration: none;
                text-align: left;
                word-wrap: break-word;
                padding-right: 0.515625px;
            }
            
            .libdetails-0-2-1 {
                display: flex;
                flex-shrink: 0;
                margin-top: 10px;
                padding-right: 1px;
            }
            
            .libdetails-image_2 {
                width: 18px;
                height: 18px;
                flex-shrink: 0;
                background-image: url('https://complex-houses.surge.sh/897c35eb-bf13-400d-b293-7acb6f8899af/original');
                background-size: contain;
                background-position: center;
                background-repeat: no-repeat;
            }
            
            .libdetails-0-2-1-1 {
                display: flex;
                flex-direction: column;
                margin-left: 10px;
                padding-top: 1px;
                padding-bottom: 1px;
            }
            
            .libdetails-0-2-1-1-0 {
                display: flex;
                flex-shrink: 0;
            }
            
            .libdetails-11 {
                flex-shrink: 0;
                font-family: "Lato", sans-serif;
                color: rgb(107, 107, 107);
                font-size: 14px;
                line-height: 16px;
                letter-spacing: 0px;
                font-weight: normal;
                font-style: normal;
                text-decoration: none;
                text-align: left;
                word-wrap: break-word;
                padding-right: 0.921875px;
            }
            
            .libdetails-star-7 {
                flex-shrink: 0;
                margin-left: 10px;
                display: flex;
                flex-direction: column;
                min-width: 70px;
            }
            
            .libdetails-0-3 {
                height: 0px;
                flex-grow: 1;
                flex-basis: 0px;
            }
            
            .libdetails-0-4 {
                display: flex;
                flex-direction: column;
                padding-top: 10px;
                padding-bottom: 15px;
            }
            
            .libdetails-0-4-0 {
                display: flex;
                flex-shrink: 0;
            }
            
            .libdetails-installationhuge-2 {
                flex-shrink: 0;
                display: flex;
                flex-direction: column;
            }
            
            .libdetails-1 {
                display: flex;
                flex-shrink: 0;
                flex-grow: 1;
                flex-basis: 0px;
                min-height: fit-content;
                margin-top: 19px;
                padding-left: 20px;
                padding-right: 20px;
            }
            
            .libdetails-1-0 {
                display: flex;
                flex-direction: column;
                padding-top: 6px;
                padding-bottom: 16px;
            }
            
            .libdetails-1-0-0 {
                display: flex;
                flex-shrink: 0;
            }
            
            .libdetails-rectangle_4 {
                display: flex;
                flex-direction: column;
            }
            
            .libdetails-1-0-0-0-0 {
                display: flex;
                flex-shrink: 0;
            }
            
            .libdetails-componenttitle-0 {
                flex-shrink: 0;
                display: flex;
                flex-direction: column;
                min-width: 206px;
            }
            
            .libdetails-1-0-0-0-1 {
                display: flex;
                flex-shrink: 0;
                margin-top: 20px;
            }
            
            .libdetails-componentlist_instance-2 {
                flex-shrink: 0;
                display: flex;
                flex-direction: column;
                min-width: 206px;
            }
            
            .libdetails-rectangle_1 {
                flex-grow: 1;
                flex-basis: 0px;
                margin-left: 30px;
                overflow: scroll;
                position: relative;
                display: flex;
                flex-direction: column;
            }
            
            .libdetails-1-1-0 {
                display: flex;
                flex-direction: column;
                flex-grow: 1;
                padding-top: 11px;
                position: absolute;
                width: 100%;
                min-height: 100%;
            }
            
            .libdetails-1-1-0-0 {
                display: flex;
                flex-shrink: 0;
                flex-grow: 1;
                flex-basis: 0px;
                min-height: fit-content;
                padding-left: 11px;
                padding-right: 11px;
            }
            
            .libdetails-1-1-0-0-0 {
                flex-grow: 1;
                flex-basis: 0px;
                display: flex;
                flex-direction: column;
                margin-top: -30px;
            }
            
            .libdetails-rectangle_7 {
                display: flex;
                flex-direction: column;
                min-height: fit-content;
                background: rgba(255, 255, 255, 0);
                margin-top: 30px;
                flex-grow: 1;
            }
            
            .libdetails-1-1-0-0-0-0-0-0 {
                display: flex;
                flex-shrink: 0;
            }
            
            .libdetails-componentpreview_instance-0 {
                flex-grow: 1;
                flex-basis: 0px;
                display: flex;
                flex-direction: column;
                min-height: 144px;
            }
            
            .libdetails-1-1-0-0-0-0-0-1 {
                width: 0px;
                flex-shrink: 0;
                flex-grow: 1;
                flex-basis: 0px;
            }
            
            * {
                box-sizing: border-box;
            }
            
            body {
                margin: 0;
            }
            
            button:hover {
                cursor: pointer;
            }
            
            a {
                text-decoration: none;
                color: inherit;
            }
            
            .pd-onhover-parent >.pd-onhover {
                display: none;
            }
            
            .pd-onhover-parent:hover > * {
                display: none;
            }
            
            .pd-onhover-parent:hover > .pd-onhover {
                display: flex;
            }
            
            .pd-onactive-parent > .pd-onactive {
                display: none;
            }
            
            .pd-onactive-parent:active > * {
                display: none;
            }
            
            .pd-onactive-parent:active > .pd-onactive {
                display: flex;
            }
            
            .pd-onactive-parent.pd-onhover-parent:active > .pd-onhover {
                display: none;
            }
        """)}),  
        React.createElement("div", {"className": "libdetails-0"},
            React.createElement("div", {"className": "libdetails-rectangle_9"},
                React.createElement("div", {"className": "libdetails-0-0-0"},
                    React.createElement("div", {"className": "libdetails-0-0-0-0"},
                        React.createElement("div", {"className": "libdetails-0-0-0-0-0"},
                            React.createElement("div", {"className": "libdetails-component_1"},
                                React.createElement(Backbutton, {"onClick": ((@props.onNavigateBack))}) 
                            )
                        )
                    ),
                    React.createElement("div", {"className": "libdetails-material_ui_-3"},
                        ( @props.title )
                    )
                )
            ),
            React.createElement("div", {"className": "libdetails-0-1"},
                React.createElement("div", {"className": "libdetails-0-1-0"},
                    React.createElement("div", {"className": "libdetails-v_0"},
                        ( "v.#{@props.version}" )
                    )
                ),
                React.createElement("div", {"className": "libdetails-0-1-1"},
                    React.createElement("div", {"className": "libdetails-by_john_appleseed_-8"},
                        ( "by #{@props.owner}" )
                    )
                )
            ),
            React.createElement("div", {"className": "libdetails-rectangle_8"},
                React.createElement("div", {"className": "libdetails-0-2-0"},
                    React.createElement("div", {"className": "libdetails-image_3"}),  
                    React.createElement("div", {"className": "libdetails-0-2-0-1"},
                        React.createElement("div", {"className": "libdetails-0-2-0-1-0"},
                            React.createElement("div", {"className": "libdetails-2"},
                                ( "#{@props.components.length} components" )
                            )
                        )
                    )
                ),
                React.createElement("div", {"className": "libdetails-0-2-1"},
                    React.createElement("div", {"className": "libdetails-image_2"}),  
                    React.createElement("div", {"className": "libdetails-0-2-1-1"},
                        React.createElement("div", {"className": "libdetails-0-2-1-1-0"},
                            React.createElement("div", {"className": "libdetails-11"},
                                ( "#{@props.installCount} installs" )
                            )
                        )
                    ),
                    React.createElement("div", {"onClick": (@props.onToggleStar), "className": "libdetails-star-7"},
                        React.createElement(Star, {"starCount": ((@props.starCount)), "starred": ((@props.starred))}) 
                    )
                )
            ),
            React.createElement("div", {"className": "libdetails-0-3"}),  
            React.createElement("div", {"className": "libdetails-0-4"},
                React.createElement("div", {"className": "libdetails-0-4-0"},
                    React.createElement("div", {"className": "libdetails-installationhuge-2"},
                        React.createElement(Installationhuge, {"installed": ((@props.installed)), "onClick": ((@props.onInstall))}) 
                    )
                )
            )
        ),
        React.createElement("div", {"className": "libdetails-1"},
            React.createElement("div", {"className": "libdetails-1-0"},
                React.createElement("div", {"className": "libdetails-1-0-0"},
                    React.createElement("div", {"className": "libdetails-rectangle_4"},
                        React.createElement("div", {"className": "libdetails-1-0-0-0-0"},
                            React.createElement("div", {"className": "libdetails-componenttitle-0"},
                                React.createElement(Componenttitle, {"title": ("Components")}) 
                            )
                        ),
                        React.createElement("div", {"className": "libdetails-1-0-0-0-1"},
                            React.createElement("div", {"className": "libdetails-componentlist_instance-2"},
                                React.createElement(Componentlist, {"components": ((@props.components))}) 
                            )
                        )
                    )
                )
            ),
            React.createElement("div", {"className": "libdetails-rectangle_1"},
                (@props.renderPreviews())
            )
        )
    )

module.exports = (props) -> render.apply({props})



// WEBPACK FOOTER //
// ./node_modules/cjsx-loader!./src/pagedraw/store/libdetails.cjsx